<template>
    <div class="px-4 py-4 sm:px-10 sm:py-10">
        <p class="text-sm" v-html="translate('body:spam', {email})"></p>
    </div>
</template>
<script>

import {Link} from "@inertiajs/inertia-vue3";
import translate from "../../../lang";
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid';


export default {
    components: {
        Link,
        ExclamationTriangleIcon,
    },
    props: {
        email: String
    },

    setup() {
        return {
            translate: translate('auth.forgotSent'),
        }
    }
}

</script>
